import React from 'react';
import ProfilePostList from './ProfilePostList';

function MyPostPaid() {
    return (
        <ProfilePostList endpoint={"post-paid"}/>
    );
}

export default MyPostPaid;